var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPantryAndSupplies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 89,
    viewBox: "0 0 166 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1002_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5556 4.22054C26.4826 3.29361 27.9349 3.14981 29.0256 3.87695L33.0002 6.52666L36.9747 3.87695C37.8985 3.26113 39.1019 3.26113 40.0256 3.87695L44.0002 6.52666L47.9747 3.87695C48.8985 3.26113 50.1019 3.26113 51.0256 3.87695L55.0002 6.52666L58.9747 3.87695C60.0655 3.14981 61.5178 3.29361 62.4447 4.22054L64.7098 6.48566L70.2703 3.70541C71.2652 3.20799 72.4617 3.35883 73.302 4.08759C74.1422 4.81635 74.4608 5.97952 74.109 7.03471L70.6283 17.477C72.417 35.4462 73.4823 50.1685 70.6428 71.8967L74.109 82.2955C74.4608 83.3507 74.1422 84.5138 73.302 85.2426C72.4617 85.9714 71.2652 86.1222 70.2703 85.6248L64.7098 82.8445L62.4447 85.1096C61.5178 86.0366 60.0655 86.1804 58.9747 85.4532L55.0002 82.8035L51.0256 85.4532C50.1019 86.069 48.8985 86.069 47.9747 85.4532L44.0002 82.8035L40.0256 85.4532C39.1019 86.069 37.8985 86.069 36.9747 85.4532L33.0002 82.8035L29.0256 85.4532C28.1019 86.069 26.8985 86.069 25.9747 85.4532L22.0002 82.8035L18.0256 85.4532C17.0481 86.1049 15.7646 86.0636 14.8309 85.3505C13.8973 84.6374 13.5198 83.41 13.8913 82.2955L17.3794 71.8311C17.2909 70.7716 17.2041 69.7404 17.1194 68.7346C15.491 49.386 14.6523 39.4206 17.3611 17.4441L13.8913 7.03471C13.5396 5.97952 13.8581 4.81635 14.6984 4.08759C15.5386 3.35883 16.7352 3.20799 17.73 3.70541L23.2905 6.48566L25.5556 4.22054ZM21.2085 11.5939L22.7757 16.2955C22.9056 16.685 22.9465 17.0987 22.8956 17.5062C20.1658 39.3444 20.966 48.8533 22.6008 68.2811C22.7001 69.4614 22.8025 70.6782 22.9073 71.9367C22.9383 72.3079 22.8935 72.6814 22.7757 73.0347L21.524 76.7899C22.207 76.67 22.9253 76.8101 23.5256 77.2103L27.5002 79.86L31.4747 77.2103C32.3985 76.5945 33.6019 76.5945 34.5256 77.2103L38.5002 79.86L42.4747 77.2103C43.3985 76.5945 44.6019 76.5945 45.5256 77.2103L49.5002 79.86L53.4747 77.2103C54.3985 76.5945 55.6019 76.5945 56.5256 77.2103L60.1498 79.6264L62.2223 77.5539C63.0593 76.7169 64.338 76.5094 65.3967 77.0387L66.7918 77.7363L65.2246 73.0347C65.0924 72.6379 65.0523 72.2162 65.1076 71.8016C67.9992 50.1145 66.9227 35.6947 65.0971 17.4387C65.0586 17.0529 65.102 16.6633 65.2246 16.2955L66.7918 11.5939L65.3967 12.2914C64.338 12.8208 63.0593 12.6133 62.2223 11.7763L60.1498 9.70377L56.5256 12.1199C55.6019 12.7357 54.3985 12.7357 53.4747 12.1199L49.5002 9.47017L45.5256 12.1199C44.6019 12.7357 43.3985 12.7357 42.4747 12.1199L38.5002 9.47017L34.5256 12.1199C33.6019 12.7357 32.3985 12.7357 31.4747 12.1199L27.8506 9.70377L25.778 11.7763C24.9411 12.6133 23.6624 12.8208 22.6037 12.2914L21.2085 11.5939Z",
    fill: "url(#paint0_linear_1002_8179)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5835 37.3318C26.5835 35.813 27.8147 34.5818 29.3335 34.5818H58.6668C60.1856 34.5818 61.4168 35.813 61.4168 37.3318V51.9984C61.4168 53.5172 60.1856 54.7484 58.6668 54.7484H29.3335C27.8147 54.7484 26.5835 53.5172 26.5835 51.9984V37.3318ZM32.0835 40.0818V49.2484H55.9168V40.0818H32.0835Z",
    fill: "url(#paint1_linear_1002_8179)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4168 17.1651C17.4168 15.6463 18.6481 14.4151 20.1668 14.4151H67.8335C69.3523 14.4151 70.5835 15.6463 70.5835 17.1651C70.5835 18.6839 69.3523 19.9151 67.8335 19.9151H20.1668C18.6481 19.9151 17.4168 18.6839 17.4168 17.1651Z",
    fill: "url(#paint2_linear_1002_8179)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4168 72.1651C17.4168 70.6463 18.6481 69.4151 20.1668 69.4151H67.8335C69.3523 69.4151 70.5835 70.6463 70.5835 72.1651C70.5835 73.6839 69.3523 74.9151 67.8335 74.9151H20.1668C18.6481 74.9151 17.4168 73.6839 17.4168 72.1651Z",
    fill: "url(#paint3_linear_1002_8179)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1002_8179)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.8322 8.91504C81.9645 8.91504 78.9758 12.3113 79.4676 16.1477L86.989 74.8143C87.3995 78.0165 90.1252 80.415 93.3536 80.415H118.993C122.052 80.415 124.685 78.2561 125.285 75.2568L126.27 70.3316H143.002C147.529 70.3316 151.128 66.533 150.885 62.0129L149.712 40.2437C149.597 38.0945 148.608 36.0858 146.976 34.6826L138.133 27.0791C137.417 26.4634 136.618 25.9967 135.777 25.6789C136.122 21.4982 139.76 18.0817 144.367 18.0817C147.271 18.0817 149.808 19.4509 151.362 21.5139C150.208 22.9215 149.817 24.8897 150.506 26.7147L152.276 31.4008C153.304 34.1198 156.34 35.4913 159.059 34.4642L160.343 33.9792C163.062 32.9521 164.434 29.9153 163.407 27.1963L161.637 22.5103C160.8 20.2962 158.631 18.9756 156.386 19.1161C153.888 15.1739 149.419 12.5817 144.367 12.5817C141.313 12.5817 138.464 13.5339 136.137 15.1609C136.053 11.766 133.27 8.91504 129.72 8.91504H85.8322ZM115.114 62.0139C114.913 65.745 117.331 68.9843 120.727 70.0011L119.892 74.1781C119.806 74.6066 119.43 74.915 118.993 74.915H93.3536C92.8924 74.915 92.503 74.5724 92.4444 74.1149L86.3183 26.3317H128.698L128.677 26.4502C128.393 26.6354 128.119 26.8408 127.855 27.0662L119.038 34.6089C117.397 36.0127 116.403 38.0274 116.287 40.1838L115.114 62.0139ZM129.675 20.8317L130.623 15.492C130.723 14.9304 130.291 14.415 129.72 14.415H85.8322C85.2797 14.415 84.8527 14.9002 84.923 15.4483L85.6132 20.8317H129.675ZM158.178 28.9179L156.575 24.6758L155.735 24.9931L157.338 29.2352L158.178 28.9179ZM145.393 62.3088L145.381 62.0817H120.618L120.606 62.3091C120.532 63.6798 121.624 64.8317 122.996 64.8317H143.002C144.375 64.8317 145.467 63.6796 145.393 62.3088ZM144.22 40.5395L145.084 56.5817H120.913L121.779 40.479C121.814 39.825 122.116 39.214 122.613 38.7883L131.43 31.2455C132.328 30.4775 133.652 30.4792 134.548 31.2494L143.391 38.853C143.885 39.2785 144.185 39.8877 144.22 40.5395Z",
    fill: "url(#paint4_linear_1002_8179)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1002_8179",
    x1: 13.75,
    y1: 85.915,
    x2: 78.75,
    y2: 82.2027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1002_8179",
    x1: 13.75,
    y1: 85.915,
    x2: 78.75,
    y2: 82.2027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1002_8179",
    x1: 13.75,
    y1: 85.915,
    x2: 78.75,
    y2: 82.2027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1002_8179",
    x1: 13.75,
    y1: 85.915,
    x2: 78.75,
    y2: 82.2027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1002_8179",
    x1: 79.4145,
    y1: 80.4149,
    x2: 169.555,
    y2: 72.1348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E5FF4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1002_8179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white",
    transform: "translate(0 0.665039)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1002_8179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white",
    transform: "translate(78 0.665039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPantryAndSupplies);
export default __webpack_public_path__ + "static/media/Pantry_and_supplies.278f176f2acd534758dd1518e1579931.svg";
export { ForwardRef as ReactComponent };